import React from 'react';
import PropTypes from 'prop-types';
import {
  Container,
  LabelText,
  HiddenRadio,
  StyledRadioWrapper,
  InnerCircle,
} from './components/RadioStyles';
import { useRadio } from './hooks/useRadio';
import { getRadioLabel } from './utils/radioHelpers';

const Radio = ({ checked, onChange, value, name, label, disabled, ...rest }) => {
  const { handleChange } = useRadio({ onChange, disabled });
  const displayLabel = getRadioLabel(label);

  return (
    <Container disabled={disabled}>
      <HiddenRadio
        checked={checked}
        onChange={handleChange}
        value={value}
        name={name}
        disabled={disabled}
        {...rest}
      />
      <StyledRadioWrapper checked={checked} disabled={disabled}>
        <InnerCircle checked={checked} />
      </StyledRadioWrapper>
      {displayLabel && <LabelText>{displayLabel}</LabelText>}
    </Container>
  );
};

Radio.propTypes = {
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  name: PropTypes.string,
  label: PropTypes.string,
  disabled: PropTypes.bool,
};

Radio.defaultProps = {
  checked: false,
  onChange: undefined,
  value: undefined,
  name: undefined,
  label: '',
  disabled: false,
};

export default Radio;



// WEBPACK FOOTER //
// ./src/design-system/atoms/Radio/Radio.jsx